document.addEventListener('DOMContentLoaded', () => {
  console.log("### Loading Custom Logic");
  cookMode();
});


function cookMode() {
    const $root = $('.c-cook-mode')
    let screenLock = null
    let isSelected = false
    let fallbackVideo = null

    // Tiny silent MP4 used as fallback (sourced from NoSleep.js, MIT License)
    const TINY_SILENT_MP4 = 'data:video/mp4;base64,AAAAHGZ0eXBpc29tAAAAAGlzb21pc28yYXZjMQAAAAhmcmVlAAAAG21kYXQAAAC8BKZ3mQAB9/8ABZAAAPpQAAACAAADSAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAABAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAAABm1wNDFpc28yYXZjMQAAADhtb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAABAAABAAABAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAABAAAAAAABAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAB0cmFrAAAAXHRraGQAAAAAAAAAAAAAAAAAAAPoAAAAAAAABAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAXAAAAAABAAAAAAABAAAAAAABAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABkAAAAAAAAAAAAAAAAAAAAAAAABAAABdWR0YQAAAB9tZXRhAAAAAAAAACFoZGxyAAAAAAAAAABtZGlyYXBwbAAAAAAAAAAAAAAAAAAAAAAA'

    if (!$root.length) {
        return
    }
    const $toggler = $root.find('.cook-mode-toggle')
    const $target = $('.shg-c .shg-c .shg-c .shogun-heading-component')

    // Only move the control if the target exists; otherwise leave it in place
    if ($target.length) {
        $root.detach().insertBefore($target.last())
    }

    // Click to toggle wake lock
    $toggler.on('click', async () => {
        if (!isSelected) {
            await initScreenLock()
        } else {
            await removeScreenLock()
        }
    })

    // Re-acquire on visibility return if user left it enabled
    document.addEventListener('visibilitychange', async () => {
        if (document.visibilityState === 'visible' && isSelected && !screenLock) {
            if ('wakeLock' in navigator) {
                try {
                    screenLock = await navigator.wakeLock.request('screen')
                    screenLock.addEventListener('release', () => {
                        isSelected = false
                        $toggler.removeClass('active')
                        screenLock = null
                    })
                } catch (e) {
                    console.warn('Could not re-acquire wake lock on visibilitychange, using fallback:', e)
                    await startFallbackVideo()
                }
            } else {
                await startFallbackVideo()
            }
        }
    })

    async function initScreenLock() {
        if ('wakeLock' in navigator) {
            try {
                screenLock = await navigator.wakeLock.request('screen')
                isSelected = true
                $toggler.addClass('active')
                screenLock.addEventListener('release', () => {
                    isSelected = false
                    $toggler.removeClass('active')
                    screenLock = null
                })
                return
            } catch (err) {
                console.warn('Wake Lock request failed, falling back to silent video:', err)
            }
        } else {
            console.warn('Screen Wake Lock API not supported; using silent video fallback.')
        }
        // Fallback path
        await startFallbackVideo()
        isSelected = true
        $toggler.addClass('active')
    }

    async function removeScreenLock() {
        try {
            if (screenLock && typeof screenLock.release === 'function') {
                await screenLock.release()
            }
        } catch (e) {
            console.warn('Error releasing wake lock:', e)
        } finally {
            await stopFallbackVideo()
            isSelected = false
            $toggler.removeClass('active')
            screenLock = null
        }
    }

    function ensureFallbackVideo() {
        if (fallbackVideo) return fallbackVideo
        const video = document.createElement('video')
        video.setAttribute('playsinline', '')
        video.setAttribute('muted', '')
        video.muted = true
        video.loop = true
        video.autoplay = true
        video.src = TINY_SILENT_MP4
        video.style.position = 'fixed'
        video.style.left = '-9999px'
        video.style.bottom = '0'
        video.style.width = '1px'
        video.style.height = '1px'
        document.body.appendChild(video)
        fallbackVideo = video
        return video
    }

    async function startFallbackVideo() {
        const v = ensureFallbackVideo()
        try {
            await v.play()
        } catch (e) {
            console.warn('Silent video fallback could not start:', e)
        }
    }

    async function stopFallbackVideo() {
        if (!fallbackVideo) return
        try {
            fallbackVideo.pause()
        } catch (e) {}
        try {
            if (fallbackVideo.parentNode) fallbackVideo.parentNode.removeChild(fallbackVideo)
        } catch (e) {}
        fallbackVideo = null
    }
}

// Custom script to delay verification popup
// Load this after your main VerificationPopup.js

document.addEventListener('DOMContentLoaded', function() {
  // Override the original load method with a delayed version
  const verificationElements = document.querySelectorAll('[data-verification-popup]');

  verificationElements.forEach(element => {
    // Check if the element has a VerificationPopup instance
    if (element._verificationPopup && element._verificationPopup.load) {
      const originalLoad = element._verificationPopup.load;

      // Override the load method
      element._verificationPopup.load = function() {
        // Get delay from data attribute or default to 2 seconds
        const delay = parseInt(element.dataset.ageDelay, 10) || 2000;

        // Age checker is in test mode - will show immediately in editor and on live site
        if (this.ageTestMode) {
          this.showModal();
          return;
        }

        if (this.modalLinks) {
          this.modalLinks.setAttribute('tabindex', '1');
        }

        // Add delay to allow cookie banner to load first
        setTimeout(() => {
          var isAnAdult = this.readCookie('isAnAdult');
          if (!isAnAdult) {
            if (window.Shopify.designMode && !this.ageTestMode) return;
            this.showModal();
          }
        }, delay);

        // Set up event listeners immediately
        if (this.enterButton) {
          this.enterButton.addEventListener('click', this.writeCookie);
        }
        if (this.exitButton) {
          this.exitButton.addEventListener('click', this.comeBackModal);
        }
        if (this.returnButton) {
          this.returnButton.addEventListener('click', this.confirmAgeModal);
        }
      };

      // Re-initialize with the new load method
      element._verificationPopup.load();
    }
  });
});
